<script lang="ts">

import Component from 'vue-class-component'

import BubbleParamSlider from '@/components/builder/BubbleParams/BubbleParamSlider.vue'
import { BubbleParamsConfig } from '@/types'

@Component
export default class RepulsionStrengthSlider extends BubbleParamSlider {
  get param () {
    return -(this.$typedStore.primary.app.config.bubbleParams[this.paramObject.name as keyof BubbleParamsConfig] as number)
  }

  set param (newValue) {
    this.$typedStore.visualisationApp.updateBubbleParams({
      param: this.paramObject.name as keyof BubbleParamsConfig,
      value: -newValue,
    })
  }
}

</script>
